var _style, _g, _path, _g2, _g3, _polygon, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAr1On(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504 237.7",
    style: {
      enableBackground: "new 0 0 504 237.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#232326;}\n\t.st1{fill:#1D1D1F;}\n\t.st2{opacity:0.68;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.42;}\n\t.st5{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000111177700046071259600000004273267291332193954_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 213,
    height: 156,
    xlinkHref: "A1152DFC968F00F8.png",
    transform: "matrix(1.5249 0 0 1.5249 0.7905 -0.3627)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st0",
    d: "M313.1,133.2h-28.6l-4.1,7.9c-1.5,2.7-2.9,3.8-5.2,3.8c-2.5,0-4.5-1.9-4.6-4.4l0,0l0,0 c0.1-1.2,0.5-2.4,1.1-3.4l18.8-35.6c2.8-5.1,5.5-5.8,8.3-5.8s5.4,0.7,8.3,5.8L326,137c0.6,1,1,2.2,1,3.4c0,2.5-2,4.4-4.4,4.4l0,0 l0,0c-2.3,0-3.8-1-5.3-3.8L313.1,133.2z M289.2,124.3h19.3l-9.6-18.4L289.2,124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "st0",
    d: "M346.9,140c-0.1,2.6-2.4,4.7-5,4.6c-2.5-0.1-4.5-2.1-4.6-4.6v-34.5c0-8.4,2.5-9.2,9.6-9.2h20.5 c9.5,0,16.1,5.9,16.1,15.4c0.2,6.5-4.1,12.3-10.3,14.1l8.4,10.2c1.3,1.2,2.1,2.9,2.3,4.6c-0.1,2.4-2.1,4.3-4.6,4.2 c-1.8,0-3.2-0.6-5.3-3.2L362.5,127h-15.7v13H346.9z M366.7,105.1h-18.5c-1.4,0-1.4,0.7-1.4,2V118h19.8c5.3,0,7.2-2.6,7.2-6.5 S372,105.1,366.7,105.1L366.7,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st0",
    d: "M424.5,140c-0.1,2.6-2.3,4.7-5,4.6c-2.5-0.1-4.5-2.1-4.6-4.5v-16.4L393.6,104 c-1-0.9-1.6-2.2-1.6-3.6c-0.1-2.5,1.8-4.7,4.3-4.8l0,0c0.2,0,0.3,0,0.5,0c1.3,0,2.6,0.6,3.6,1.6l19.3,18l19.4-18 c0.9-1,2.2-1.5,3.5-1.6c2.5-0.2,4.7,1.8,4.9,4.3c0,0.2,0,0.3,0,0.5c0,1.4-0.6,2.6-1.6,3.6l-21.3,19.7L424.5,140z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "st0",
    d: "M490,133.2h-28.6l-4.1,7.9c-1.5,2.7-2.9,3.8-5.2,3.8c-2.5,0-4.5-1.9-4.6-4.4l0,0l0,0 c0.1-1.2,0.4-2.4,1.1-3.4l18.8-35.6c2.8-5.1,5.5-5.8,8.3-5.8s5.4,0.7,8.3,5.8l19,35.6c0.6,1,1,2.2,1,3.4c0,2.4-2,4.4-4.4,4.4l0,0 h-0.1c-2.2,0-3.8-1-5.3-3.8L490,133.2z M466.1,124.3h19.3l-9.6-18.4L466.1,124.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.1,55.3H200c14.3,0,25.9,11.6,25.9,25.9V164c0,14.3-11.6,25.9-25.9,25.9h-82.9 c-14.3,0-25.9-11.6-25.9-25.9V81.2C91.2,66.9,102.8,55.3,117.1,55.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "165,122.4 131.9,155.5 176.1,133  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.9,155.7c-0.1,0-0.2-0.1-0.2-0.2l0,0c0,0,0-0.1,0.1-0.1l33.2-33c0.1-0.1,0.1-0.1,0.2,0l0,0l11.1,10.6 l0.1,0.1c0,0.1,0,0.1-0.1,0.1L131.9,155.7L131.9,155.7z M165,122.7l-32.3,32.2l43.1-21.9L165,122.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "129.7,88.8 129.7,155.6 164,121.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.7,155.8L129.7,155.8c-0.1,0-0.2-0.1-0.2-0.1V88.8c0-0.1,0.1-0.2,0.1-0.2l0,0h0.1l34.3,32.7v0.1v0.1 l-34.3,34.2C129.8,155.7,129.8,155.8,129.7,155.8z M129.9,89.1v66.1l33.9-33.8L129.9,89.1z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "131.5,88.5 177.5,132.4 197.7,122.1  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177.5,132.5h-0.1l-46-43.9c-0.1-0.1-0.1-0.2,0-0.2s0.1,0,0.2,0l66.2,33.6c0.1,0,0.1,0.1,0.1,0.2l0,0 c0,0,0,0.1-0.1,0.1L177.5,132.5L177.5,132.5z M132.4,89.1l45.1,43l19.9-10.1L132.4,89.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.9894,
    y1: 1009.5031,
    x2: 503.8894,
    y2: 1009.5031,
    gradientTransform: "matrix(1 0 0 1 0 -840)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#13347C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#68327B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#DA9953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C23D32"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.5,179.8c-3.8,0-6.3-2.2-6.4-5.1h2c0.2,1.6,1.3,3.5,4.4,3.5c2.6,0,4.2-1.6,4.2-3.5 c0-5.6-10.5-2.1-10.5-9.2c0-2.9,2.4-5.1,6.1-5.1s5.8,2,6.1,4.6h-2.1c-0.2-1.3-1.5-3-4.1-3c-2.2,0-4.1,1.2-4.1,3.4 c0,5.5,10.5,2.1,10.5,9.2C453.6,177.2,451.5,179.8,447.5,179.8z M470.2,179.6h-1.9V177c-1,1.9-3,3-5.1,2.9c-3.4,0-6-2.1-6-6.4 v-8.7h1.9v8.5c0,3.3,1.8,5,4.5,5s4.7-1.7,4.7-5.4v-8.1h1.9V179.6z M474.1,160.5c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4l0,0 c0,0.8-0.6,1.4-1.4,1.4C474.8,161.9,474.1,161.3,474.1,160.5L474.1,160.5z M474.6,164.7h1.9v14.9h-1.9V164.7z M481.4,166.3h-2.1 v-1.6h2.1V161h1.9v3.7h4.1v1.6h-4.1v9.2c0,1.8,0.6,2.4,2.3,2.4h1.8v1.6h-2c-2.6,0-4-1.1-4-4L481.4,166.3z M497,179.8 c-4.2,0-7.3-2.9-7.3-7.6s3-7.6,7.3-7.6c3.7-0.2,6.8,2.7,7,6.3c0,0.2,0,0.4,0,0.5c0,0.5,0,1-0.1,1.5h-12.3 c-0.1,2.9,2.2,5.3,5.1,5.3c0.1,0,0.2,0,0.3,0c2.2,0.2,4.2-1.2,4.8-3.3h2C503.1,177.7,500.7,179.8,497,179.8L497,179.8z  M491.6,171.3h10.5c0.2-2.7-1.8-5-4.5-5.2c-0.2,0-0.5,0-0.7,0c-2.8-0.1-5.2,2.1-5.3,5C491.6,171.2,491.6,171.3,491.6,171.3 L491.6,171.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr1On);
export default __webpack_public_path__ + "static/media/ar-1-on.6ba0db9f93d4593d281a1abb0db4d879.svg";
export { ForwardRef as ReactComponent };